<fe-header style="z-index: 10000"></fe-header>
<main class="mb-26 mb-sm-20">
    <div class="home-hero">
        <fe-carousel (promoApplied)="onPromoApplied($event)"></fe-carousel>
        <section
            class="container-fluid reservation home-hero__reservation"
            id="doReservation"
        >
            <fe-search-reservation
                [isNormal]="true"
                [home]="true"
            ></fe-search-reservation>
        </section>
    </div>
    <fe-standard-care></fe-standard-care>
    <fe-reservation-banner></fe-reservation-banner>
    <fe-popular-destinations></fe-popular-destinations>
    <fe-featured-promotions></fe-featured-promotions>
    <fe-blog-cards></fe-blog-cards>
</main>
<fe-footer></fe-footer>
